
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { DeviceAppsAllAppsContent } from "./DeviceAppsAllAppsContent";
import { DeviceAppsWhitelistContent } from "./DeviceAppsWhitelistContent";
import { DeviceAppsBlacklistContent } from "./DeviceAppsBlacklistContent";
import { DeviceAppsCategoriesContent } from "./DeviceAppsCategoriesContent";
import { DeviceAppsInstalledContent } from "./DeviceAppsInstalledContent";

interface DeviceAppsContentProps {
  activeSection: string;
  deviceId?: string;
}

export const DeviceAppsContent = ({ activeSection, deviceId }: DeviceAppsContentProps) => {
  // Mock device data for now - replace with Convex when needed
  const device = null;
  const deviceAppRestrictions: any[] = [];
  const deviceCategoryRules: any[] = [];

  const hasLevel = !!device?.level_id;
  const hasDeviceAppRestrictions = (deviceAppRestrictions && deviceAppRestrictions.length > 0);
  const hasDeviceCategoryRules = (deviceCategoryRules && deviceCategoryRules.length > 0);
  const hasAnyRestrictions = hasLevel || hasDeviceAppRestrictions || hasDeviceCategoryRules;

  switch (activeSection) {
    case "whitelist":
      return <DeviceAppsWhitelistContent deviceId={deviceId || ''} />;
      
    case "blacklist":
      return <DeviceAppsBlacklistContent deviceId={deviceId || ''} />;
      
    case "available":
      // Always show the all apps table directly without buttons
      return (
        <div className="space-y-6 h-full flex flex-col">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">All Available Apps</h3>
            <p className="text-gray-600">All apps available for this device</p>
          </div>
          
          <div className="flex-1 flex flex-col">
            <DeviceAppsAllAppsContent deviceId={deviceId || ''} />
          </div>
        </div>
      );

    case "installed":
      return <DeviceAppsInstalledContent deviceId={deviceId || ''} />;
      
    case "categories":
      return (
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">App Categories</h3>
            <p className="text-gray-600">Manage app category permissions for this device</p>
          </div>
          <DeviceAppsCategoriesContent deviceId={deviceId || ''} />
        </div>
      );
      
    default:
      return null;
  }
};
